import { render, staticRenderFns } from "./JoinInviteForm.vue?vue&type=template&id=38f4e49f"
import script from "./JoinInviteForm.vue?vue&type=script&lang=js"
export * from "./JoinInviteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports